<app-header></app-header>
<app-view-map></app-view-map>

<!-- <main>
    <as-split direction="horizontal" *ngIf="!activatedViewDashboard" gutterSize="3" (dragEnd)="onDragEnd($event)">
        <as-split-area [size]="splitAreaSizeMap" *ngIf="activatedViewMap">
            <app-view-map></app-view-map>
        </as-split-area>
        <as-split-area [size]="splitAreaSizePanoramic" *ngIf="activatedViewPanoramic"
            [ngClass]="mapService.showPano? 'show' : 'hide'">
            <app-view-panoramic></app-view-panoramic>
        </as-split-area>
    </as-split>
    <iframe class="dashboard" *ngIf="activatedViewDashboard" [src]="safeUrl"></iframe>
    <app-sidebar #sidenav></app-sidebar>
</main> -->
<!-- <app-footer id="footer"></app-footer> -->